import { render, staticRenderFns } from "./PaymentsBlank.vue?vue&type=template&id=2130b240&scoped=true&"
import script from "./PaymentsBlank.vue?vue&type=script&lang=js&"
export * from "./PaymentsBlank.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsBlank.vue?vue&type=style&index=0&id=2130b240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130b240",
  null
  
)

export default component.exports